import { useEffect, useRef } from "react";

const API_BASE = window.location.hostname === "localhost" ? "http://localhost:5000" : "";

const CONTROL_KEY = "option_decay_controls_v1";
const DATA_KEY = "option_decay_data_v1";

const TABS = ["nifty", "sensex", "banknifty"];

function readControls() {
  try {
    return JSON.parse(localStorage.getItem(CONTROL_KEY) || "{}");
  } catch {
    return {};
  }
}

function readData() {
  try {
    return JSON.parse(localStorage.getItem(DATA_KEY) || "{}");
  } catch {
    return {};
  }
}

async function fetchDecay(tabId) {
  const res = await fetch(`${API_BASE}/api/option-decay/${tabId}?t=${Date.now()}`, {
    cache: "no-store",
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) return null;

  const cached = readData();
  const next = {
    ...cached,
    [tabId]: data,
  };

  localStorage.setItem(DATA_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("option-decay-data", { detail: next }));

  return data;
}

export default function GlobalOptionDecayFetcher() {
  const runningRef = useRef(false);

  useEffect(() => {
    const run = async () => {
      if (runningRef.current) return;
      runningRef.current = true;

      try {
        const controls = readControls();

        await Promise.all(
          TABS.map(tabId => {
            const control = controls[tabId] || {};
            if (control.started && control.autoRefresh) {
              return fetchDecay(tabId).catch(() => null);
            }
            return null;
          })
        );
      } finally {
        runningRef.current = false;
      }
    };

    run();

    const timer = setInterval(run, 1000);

    const manualRun = () => run();
    window.addEventListener("option-decay-control", manualRun);

    return () => {
      clearInterval(timer);
      window.removeEventListener("option-decay-control", manualRun);
    };
  }, []);

  return null;
}